<template>
  <div class="creator-search-view">
    <v-row no-gutters>
      <v-col cols="12" class="creator-search-view__content">
        <search-creators-data-table />
      </v-col>
    </v-row>
  </div>
</template>
<script>
import SearchCreatorsDataTable from './DataTable'
export default {
  name: 'search-creators',
  components: {
    SearchCreatorsDataTable
  },
  props: [
    'refresh'
  ],
  data() {
    return {
      isRefresh: 1
    }
  },
  methods: {
  }
}
</script>

<style scoped>
.creator-search-view {
  min-height: 100%;
  padding: 10px 16px 28px;
  background:
    radial-gradient(circle at top right, rgba(245, 166, 35, 0.11), transparent 28rem),
    #f6f7fb;
}

.creator-search-view__content {
  max-width: 1800px;
  margin: 0 auto;
}

@media (max-width: 600px) {
  .creator-search-view {
    padding: 8px 8px 22px;
  }
}
</style>



// WEBPACK FOOTER //
// index.vue?5062aeee